import React from 'react';
//import config from '../../config';

export default function ServicesCards() {
  return (
    <section className="projects-section">
        <h2 className="text-white text-center">Our Services</h2>
        <div className="row">
          <div className="col-md-4 mb-3 mb-md-0">
            <div className="card card-no-bg py-4 h-100">
              <div className="card-body text-white text-center">
                {/*  <h3><i className="fas fa-desktop  mb-2"></i></h3> */}
                <h3>
                  <i title="Wrench Icon" className="fas fa-wrench  mb-2"></i>
                </h3>
                <h4 title="Web Development" className="m-0">Web Development</h4>
                <hr className="my-4 bg-white" />
                <div className="small text-center-75 text-white text-lg-left pl-2 ">
                  <div title="UI/UX Design" > - UI/UX Design </div>
                  <div title="Logo and Branding " > - Logo and Branding </div>
                  <div title="Responsive Website Design" > - Responsive Website Design</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3 mb-md-0">
            <div className="card card-no-bg py-4 h-100">
              <div className="card-body text-white text-center">
                <h3>
                  <i title="Mobile Device Icon" className="fas fa-mobile-alt mb-2"></i>
                </h3>
                <h4 title="App Development" className="m-0">App Development</h4>
                <hr className="my-4 bg-white" />
                <div className="small text-center text-white-75 text-lg-left pl-2 ">
                  <div title="Web App Developmen" >- Web App Development</div>
                  <div title="Mobile App Development" >- Mobile App Development </div>
                  <div title="Powerful Online Tools" >- Powerful Online Tools </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3 mb-md-0">
            <div className="card card-no-bg py-4 h-100">
              <div className="card-body text-white text-center">
                <h3>
                  <i title="Paint Brush Icon" className="fas fa-paint-brush mb-2"></i>
                </h3>
                <h4 title="Custom Design" className="m-0">Custom Design</h4>
                <hr className="my-4 bg-white" />
                <div className="small   text-center text-lg-left pl-2  text-white-75">
                  <div title="Custom Software Design" >- Custom Software Design </div>
                  <div title="Innovative Solutions" >- Innovative Solutions</div>
                  <div title="Solutions for your unique Business" >- Solutions for your unique Business</div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
}
